// extracted by mini-css-extract-plugin
export default {"root":"HeaderSection_root__aIl+L","title":"HeaderSection_title__NfAps"};